<template>
  <RevSkeleton v-if="isLoading" height="220px" shape="line" width="100%" />
  <div
    v-else
    class="bg-action-default-hi text-static-light-hi mood-main flex flex-col p-16 md:rounded-lg md:flex-row md:items-start md:p-24"
    data-test="app-download-banner"
  >
    <div
      class="hidden justify-center px-24 align-middle md:flex md:w-1/3 md:justify-end"
    >
      <div
        class="bg-static-default-min rounded-lg flex h-160 self-center overflow-hidden"
      >
        <RevIllustration
          alt="QR Code"
          :height="160"
          sizes="160px"
          src="/img/lead-collection/QR-code.svg"
          :width="160"
        />
      </div>
    </div>

    <div class="w-full md:max-w-[32vw]">
      <h2 class="heading-1">{{ title }}</h2>
      <p class="mb-12">{{ description }}</p>

      <AppStoreButtons
        apple-store-tracking-name="apple_store"
        :apple-store-url="APPSFLYER_APPLE_STORE_URL"
        :campaign="trackingZone"
        :class="buttonClasses"
        play-store-tracking-name="google_play_store"
        :play-store-url="APPSFLYER_GOOGLE_PLAY_URL"
        :show-in-all-countries="true"
        :tracking-zone
        @click="handleClick"
      />

      <Dropdown
        v-if="hasTerms"
        :description="termsDescription"
        :title="termsTitle"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import AppStoreButtons from '@backmarket/nuxt-layer-base/components/AppStoreButtons/AppStoreButtons.vue'
import { RevIllustration } from '@ds/components/Illustration'
import { RevSkeleton } from '@ds/components/Skeleton'

import Dropdown from '../Dropdown/Dropdown.vue'

import {
  APPSFLYER_APPLE_STORE_URL,
  APPSFLYER_GOOGLE_PLAY_URL,
} from './AppDownload.constants'

const emit = defineEmits(['actioned'])

const props = withDefaults(
  defineProps<{
    isLoading?: boolean
    title: string
    description: string

    termsTitle?: string
    termsDescription?: string

    trackingZone: string
  }>(),
  {
    isLoading: false,
    termsTitle: '',
    termsDescription: '',
  },
)

const hasTerms = computed(() => {
  return !!(props.termsTitle && props.termsDescription)
})

const buttonClasses = computed(() => {
  return hasTerms.value ? 'mb-12' : 'mb-0'
})

function handleClick() {
  emit('actioned')
}
</script>
